<template>
  <div class="b-card-container flex-1">
    <div class="bc-header-container">
      <div class="bc-header">
        Muted Chronic Alerts
      </div>
      <div class="bc-header">
        Total: {{ chronicAlerts.length }}
      </div>
    </div>
    <div class="chronic-table-container">
      <div class="chronic-header-container">
        <div class="chronic-header">
          UID
        </div>
        <div class="chronic-header">
          Alert Type
        </div>
        <div class="chronic-header">
          Muted Date
        </div>
        <div class="chronic-header">
          Unmute Date
        </div>
        <div class="chronic-header">
          Notes
        </div>
        <div class="chronic-header" />
      </div>
      <div
        v-for="(c, idx) in chronicAlerts"
        :key="idx"
        class="chronic-body-container"
      >
        <div
          :key="c.uid"
          class="chronic-row-container"
        >
          <div class="chronic-body">
            ...{{ c.uid.slice(14, 20) }}
          </div>
          <div class="chronic-body">
            {{ c.alertType }}
          </div>
          <div class="chronic-body">
            {{ formattedDate(c.creationDate) }}
          </div>
          <div class="chronic-body">
            {{ formattedDate(c.unmuteDate) }}
          </div>
          <div class="chronic-body">
            {{ c.note ? c.note : '--' }}
          </div>
          <div class="chronic-body">
            <button @click="removeChronicAlert(c.uid, c.alertType)">
              <img
                class="chronic-button"
                src="@shared/assets/img/table/x.svg"
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'ChronicDetail',
  mixins: [customerDetailMixin],
};
</script>
